import { useQuery } from '@apollo/client';
import { useContext } from 'react';

import { localStorageGhostModeName } from '../../../constants/ghostMode';
import { isDemoEnvironment } from '../../../constants/global';
import { GhostModeContext } from '../../../context/GhostMode/GhostMode';
import { handleGql403 } from '../../../utils';
import { MyPermissionsQuery, MyPermissionsQueryVariables } from '../types';
import { mockMyPermissions } from './mock';
import { MY_PERMISSIONS } from './myPermissions';

type UseMyPermissions = {
  data?: MyPermissionsQuery['myPermissions'];
  loading: boolean;
};

type Options = {
  skipIfOrgIdEmpty?: boolean;
};

const useMyPermissions = (userId?: string, organizationId?: string, options: Options = {}): UseMyPermissions => {
  const { isGhostMode } = useContext(GhostModeContext);
  const ghostModeData = localStorage.getItem(localStorageGhostModeName);
  const ghostData = ghostModeData ? JSON.parse(ghostModeData) : undefined;
  const { data, loading } = useQuery<MyPermissionsQuery, MyPermissionsQueryVariables>(MY_PERMISSIONS, {
    variables: {
      userId: isGhostMode && ghostData ? ghostData.userId : String(userId),
      organizationId: isGhostMode && ghostData ? ghostData.organizationId : organizationId,
      isGhostMode: isGhostMode ? true : undefined,
    },
    skip: !userId || (options.skipIfOrgIdEmpty && !organizationId) || isDemoEnvironment,
    onError: handleGql403,
  });

  return {
    data: isDemoEnvironment ? { ...mockMyPermissions, adAccountPermissions: null } : data?.myPermissions,
    loading,
  };
};

export default useMyPermissions;
